import { FieldValues, Control, Path } from 'react-hook-form';
import { Typography, Label } from '@ui/components';
import { MaskitoOptions } from '@maskito/core';
import { useTranslation } from 'react-i18next';
import { FormInput } from '@ui/components';
import { Masks } from '@helpers/constant';

interface AddressFormProps<T extends FieldValues> {
  prefix: 'correspondenceAddress' | 'primaryAddress';
  control: Control<T>;
  disabled?: boolean;
}

export const AddressForm = <T extends FieldValues>({
  control,
  prefix,
  disabled,
}: AddressFormProps<T>) => {
  const { t } = useTranslation();
  return (
    <>
      <Label htmlFor={`${prefix}.street`} className="col-span-2">
        <Typography variant="labelSmallBook" className="text-weak" element="label">
          {t('COMPANY_ACCOUNT_MANAGEMENT.STREET')}
        </Typography>
      </Label>
      <FormInput
        componentProps={{
          id: `${prefix}.street`,
        }}
        placeholder={t('COMPANY_ACCOUNT_MANAGEMENT.STREET')}
        name={`${prefix}.street` as Path<T>}
        className="w-full col-span-4"
        formControl={control}
        disabled={disabled}
        size="small"
        required
      />

      <Label htmlFor={`${prefix}.buildingNumber`} className="col-span-2">
        <Typography variant="labelSmallBook" className="text-weak" element="label">
          {t('COMPANY_ACCOUNT_MANAGEMENT.BUILDING_NUMBER')}
        </Typography>
      </Label>
      <FormInput
        componentProps={{
          id: `${prefix}.buildingNumber`,
        }}
        placeholder={t('COMPANY_ACCOUNT_MANAGEMENT.BUILDING_NUMBER')}
        name={`${prefix}.buildingNumber` as Path<T>}
        className="w-full col-span-4"
        formControl={control}
        disabled={disabled}
        size="small"
        required
      />

      <Label htmlFor={`${prefix}.apartmentNumber`} className="col-span-2">
        <Typography variant="labelSmallBook" className="text-weak" element="label">
          {t('COMPANY_ACCOUNT_MANAGEMENT.APARTMENT_NUMBER')}
        </Typography>
      </Label>
      <FormInput
        componentProps={{
          id: `${prefix}.apartmentNumber`,
        }}
        placeholder={t('COMPANY_ACCOUNT_MANAGEMENT.APARTMENT_NUMBER')}
        name={`${prefix}.apartmentNumber` as Path<T>}
        className="w-full col-span-4"
        formControl={control}
        disabled={disabled}
        size="small"
      />

      <Label htmlFor={`${prefix}.zipCode`} className="col-span-2">
        <Typography variant="labelSmallBook" className="text-weak" element="label">
          {t('COMPANY_ACCOUNT_MANAGEMENT.POSTAL_CODE')}
        </Typography>
      </Label>
      <FormInput
        componentProps={{
          id: `${prefix}.zipCode`,
          maskOptions: { mask: Masks.ZIP_CODE } as MaskitoOptions,
        }}
        placeholder={t('COMPANY_ACCOUNT_MANAGEMENT.POSTAL_CODE')}
        name={`${prefix}.zipCode` as Path<T>}
        className="w-full col-span-4"
        formControl={control}
        disabled={disabled}
        size="small"
        required
      />

      <Label htmlFor={`${prefix}.city`} className="col-span-2">
        <Typography variant="labelSmallBook" className="text-weak" element="label">
          {t('COMPANY_ACCOUNT_MANAGEMENT.CITY')}
        </Typography>
      </Label>
      <FormInput
        componentProps={{
          id: `${prefix}.city`,
        }}
        placeholder={t('COMPANY_ACCOUNT_MANAGEMENT.CITY')}
        name={`${prefix}.city` as Path<T>}
        className="w-full col-span-4"
        formControl={control}
        disabled={disabled}
        size="small"
        required
      />
    </>
  );
};
